module.exports = __webpack_public_path__ + "static/media/angular.f4dd711a.svg";